export default class ProductsSet {
    id = ''
    name = ''
    count = 0

    constructor(set) {
        if (set) {
            this.id = set.id
            this.name = set.name
            this.count = parseInt(set.count)
        }
    }
}
